"use client";

// import Image from "next/image";
// import { LoanTypeBanner, TopShape, SectionTop } from "@assets/icons";
// import { Button } from "@components/ui";
import { FaRegThumbsUp } from "react-icons/fa";
import React from "react";

const EqualBenefits = () => {
    return (
        <section className="bg-white text-left pt-5 pb-[500px]  2xl:pb-0">
            <div className="container mx-auto px-4 flex flex-col md:flex-row gap-2 content-center w-[330px] sm:w-full h-[456px] 2xl:w-[1030px] 2xl:gap-10 2xl:h-[352px] md:h-auto">
                {/* Fixed Rate Column */}
                <div className="flex-1 space-y-4">
                    <h2 className="text-[30px] w-[300px] sm:w-full h-[40px] font-bold text-darkBlue uppercase 2xl:w-[585px]">
                        Fixed Rate
                    </h2>

                    <p className="text-[15px] text-black leading-[26px] w-[300px] sm:w-full h-[160px] 2xl:w-[585px] 2xl:h-[130px] md:h-auto">
                        A fixed-rate home loan is a loan with an interest rate that never changes. A popular term
                        (length) for fixed-rate loans is 30 years, but we offer custom term options, as well. Fixed-rate
                        loans with shorter terms tend to require higher monthly payments, but less total interest paid
                        over the life of the loan.
                    </p>

                    <div className="bg-[#f2f2f2] p-4 rounded w-[295px] sm:w-full h-auto !mt-8 2xl:w-[580px] 2xl:h-auto 2xl:!mt-0">
                        <div className="flex items-center gap-3">
                            <FaRegThumbsUp className="text-2xl text-[#212459]" aria-hidden="true" focusable="false" />
                            <h3 className="text-[22px] w-[224px] sm:w-full h-[33px] font-extrabold uppercase text-[#212459] 2xl:w-[224px]">
                                Benefits
                            </h3>
                        </div>
                        <p className="text-[15px] mt-2 leading-normal w-[265px] sm:w-full h-auto 2xl:w-[550px]">
                            You lock in the security of a consistent rate, which is ideal if you plan to stay in the
                            same home for a long time. And if rates suddenly go up, you’ll keep the rate you had the day
                            you closed on your loan.
                        </p>
                    </div>
                </div>

                {/* Adjustable Rate Column */}
                <div className="flex-1 space-y-4">
                    <h2 className="text-[30px] font-bold text-darkBlue uppercase w-[300px] sm:w-full h-[40px] 2xl:w-[585px]">
                        Adjustable-Rate
                    </h2>

                    <p className="text-[15px] text-black leading-normal w-[300px] sm:w-full 2xl:w-[585px] 2xl:h-[130px]">
                        With an adjustable-rate mortgage (ARM), your rate may change based on national rate indexes
                        (within certain limits). Adjustable-rate home loans have an initial fixed rate period after
                        which the rate will adjust at stated periods. For example, a “5/1 ARM” is a loan with a fixed
                        rate for 5 years, then one yearly adjustment for the rest of the loan term. Each adjustment has
                        annual and lifetime limits.
                    </p>

                    <div className="bg-[#f2f2f2] p-4 rounded w-[295px] sm:w-full h-auto !mt-8 2xl:w-[580px] 2xl:h-[140px] 2xl:!mt-0">
                        <div className="flex items-center gap-3">
                            <FaRegThumbsUp className="text-2xl text-[#212459]" aria-hidden="true" focusable="false" />
                            <h3 className="text-[22px] w-[224px] sm:w-full h-[33px] font-extrabold uppercase text-[#212459] 2xl:w-[224px]">
                                Benefits
                            </h3>
                        </div>
                        <p className="text-[15px] mt-2 leading-normal w-[265px] sm:w-full h-auto 2xl:w-[550px]">
                            If you’re planning on staying in your home for a shorter period of time, the initial low
                            fixed rate of a 3/1, 5/1 or 10/1 ARM can keep your monthly payments low.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EqualBenefits;
